module.exports = __webpack_public_path__ + "img/blog-Abhinaya.50cfe29d.png";